
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M455.937 379.708V13.223H56.063v366.484H0v119.069h512V379.708h-56.063zm-215.999-.001H89.454v-149.85h150.483v149.85zm0-183.241H89.454V46.615h150.483v149.851zm182.609 183.242H273.329v-149.85h149.218v149.85zm0-183.242H273.329V46.615h149.218v149.851z"}})])
          )
        }
      }
    